import { render, staticRenderFns } from "./DevHis.vue?vue&type=template&id=2a7dec8a&"
import script from "./DevHis.vue?vue&type=script&lang=js&"
export * from "./DevHis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports